import React from 'react';
import { Outlet } from 'react-router';

import { MenuOptions, Navigation } from 'shared/components/Navigation/Navigation';
import { useUser } from 'hooks/useUser';
import { FlagKey } from 'api/types';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import { getDashboardRedirectPath } from 'modules/auth/Auth.utils';
import { LayoutContent, LayoutContentInner, LayoutWrapper, MenuBar } from './Layout.styles';
import { Footer } from '../Footer/Footer';

type Props = {
  isAuthScreen?: boolean;
  menuOptions?: MenuOptions[];
  hasNav?: boolean;
  hasFooter?: boolean;
  children?: JSX.Element;
};

export function Layout({ menuOptions, hasNav, hasFooter = true, isAuthScreen, children }: Props) {
  const { userResult, selectedAgreement } = useUser();
  const {
    flags: { [FlagKey.onboardingRefresh]: onboardingRefresh },
  } = useFeatureFlags();
  const { hasDashboardAccess } = getDashboardRedirectPath(
    userResult?.user,
    selectedAgreement,
    onboardingRefresh,
  );

  // we check for selectedAgreement here because the pre-PTO nav components are only relevant to active agreements
  const isPrePTO = Boolean(onboardingRefresh && selectedAgreement && !hasDashboardAccess);

  return (
    <LayoutWrapper $isPrePTO={isPrePTO}>
      {hasNav && (
        <MenuBar $isPrePTO={isPrePTO}>
          <Navigation menuOptions={menuOptions || []} isPrePTO={isPrePTO} />
        </MenuBar>
      )}
      <LayoutContent $isAuthScreen={isAuthScreen} $isPrePTO={isPrePTO}>
        <LayoutContentInner $isAuthScreen={isAuthScreen}>
          {children || <Outlet />}
          {hasFooter && <Footer />}
        </LayoutContentInner>
      </LayoutContent>
    </LayoutWrapper>
  );
}

export default Layout;
